// ArticleCatalog.jsx
import AuthenticatedImage from "../../../Common/AuthenticatedImage";
import "./ArticleCatalog.css";

const defaultCanCheck = () => true;

const ArticleCatalog = ({
    articles,
    search,
    selectedArticle,
    onSelect,
    checkedIds,
    onCheckedIdsChange,
    canCheck = defaultCanCheck,
    checkboxDisabledTitle = "Not available",
    renderBadge,
}) => {
    const filtered = (() => {
        const q = search.toLowerCase();
        return articles.filter(
            (a) =>
                a.name?.toLowerCase().includes(q) ||
                a.manufacturer?.toLowerCase().includes(q) ||
                a.type?.toLowerCase().includes(q) ||
                a.articleNumber?.toLowerCase().includes(q)
        );
    })();

    const toggleItem = (id) => {
        const next = new Set(checkedIds);
        next.has(id) ? next.delete(id) : next.add(id);
        onCheckedIdsChange(next);
    };

    if (filtered.length === 0) {
        return <div className="ac-catalog-empty">No articles found.</div>;
    }

    return (
        <div className="ac-catalog-grid">
            {filtered.map((article) => {
                const checkable = canCheck(article);
                const thumb = article.images?.[0];

                return (
                    <div
                        key={article.id}
                        className={`ac-card ${
                            selectedArticle?.id === article.id ? "selected" : ""
                        }`}
                        onClick={() => onSelect(article)}
                    >
                        <input
                            type="checkbox"
                            className="ac-card-checkbox"
                            checked={checkedIds.has(article.id)}
                            disabled={!checkable}
                            title={!checkable ? checkboxDisabledTitle : undefined}
                            onChange={() => toggleItem(article.id)}
                            onClick={(e) => e.stopPropagation()}
                        />

                        {renderBadge?.(article)}

                        <div className="ac-card-thumb">
                            {thumb ? (
                                <AuthenticatedImage
                                    articleId={article.id}
                                    blobName={thumb}
                                    alt={article.name}
                                />
                            ) : (
                                <div className="ac-card-thumb-placeholder">No image</div>
                            )}
                        </div>

                        <div className="ac-card-body">
                            <div className="ac-card-name" title={article.name}>
                                {article.name}
                            </div>
                            <div className="ac-card-manufacturer">
                                {article.manufacturer || "—"}
                            </div>
                            <div className="ac-card-number">{article.articleNumber || ""}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ArticleCatalog;